import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { FRAUD_TYPE, FRAUD_TYPE_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetFraudTypeHistorical,
    asyncPatchFraudTypeParam,
    asyncPostFraudTypeParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useFraudTypeForm = () => {
    const navigate = useNavigate();
    const { idFraudType } = useParams();
    const [fraudType, setFraudType] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikFraudTypeData, setFormikFraudTypeData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [fraudTypeHistorical, setFraudTypeHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikFraudTypeData?.isValid;

    const handleCleanAndBack = () => {
        formikFraudTypeData?.resetForm();
        navigate(FRAUD_TYPE);
    };

    const handleSubmit = async () => {
        await formikFraudTypeData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikFraudTypeData?.values;

        let res: any | undefined = undefined;

        try {
            if (fraudType && fraudType.id)
                res = await asyncPatchFraudTypeParam(fraudType.id, data);
            else res = await asyncPostFraudTypeParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! la tipología de fraude se ${
                    fraudType && fraudType.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${FRAUD_TYPE_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    fraudType && fraudType.id ? 'actualizar' : 'crear'
                } la tipología de fraude. Por favor, asegúrate de ${
                    fraudType && fraudType.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idFraudType)) {
            setLoading(true);
            asyncGetParam(idFraudType)
                .then((fraudType: any) => {
                    if (!fraudType || !fraudType.items) navigate(FRAUD_TYPE);
                    setFraudType(fraudType?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idFraudType]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetFraudTypeHistorical(idFraudType)
                .then((resp) => {
                    if (resp) setFraudTypeHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        fraudType,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikFraudTypeData,
        fraudTypeHistorical,
        showHistorical,
        setShowHistorical,
    };
};
